<template>
  <div class="mb-2">
    <AppFilter :filters="filterConfig" :filter-submitting="filterSubmitting" @filter="handleFilter">
      <template #extra-actions>
        <b-button
          id="create-new-btn"
          variant="primary"
          class="create-new-btn"
          @click="createCostPrice"
        >
          <feather-icon icon="PlusIcon" size="15" />
          {{ $t('Create Additional Fee') }}
        </b-button>
      </template>
    </AppFilter>
  </div>
</template>

<script>
import AppFilter from '@/components/AppFilter/AppFilter.vue';
import { helper } from '@core/mixins/helper';
import { BButton } from 'bootstrap-vue';
import useService from '@/auth/service/useService';

export default {
  name: 'CostPricesFilter',

  components: {
    AppFilter,
    BButton
  },

  mixins: [helper],

  props: {
    values: {
      type: Object,
      required: true
    },
    filterSubmitting: {
      type: Boolean,
      required: true,
      default: false
    }
  },

  data() {
    return {
      serviceProviderOptions: []
    };
  },

  computed: {
    filterConfig() {
      return [
        {
          id: 'provider',
          label: this.$t('Service Provider'),
          type: 'select',
          options: this.serviceProviderOptions,
          placeholder: this.$t('Make a Choice')
        }
      ];
    }
  },

  async created() {
    await this.loadFilterOptions();
  },

  methods: {
    handleFilter(filters) {
      this.$emit('filter', filters);
    },

    createCostPrice() {
      this.$router.push({ name: 'cost-prices-additional-fees-create' });
    },

    async loadFilterOptions() {
      try {
        const [providersResponse] = await Promise.all([
          useService.getAllProviders({ paginated: false })
        ]);

        this.serviceProviderOptions = providersResponse.data.map(item => ({
          value: item.id,
          label: item.name
        }));
      } catch (error) {
        this.showErrorMessage(error);
      }
    }
  }
};
</script>
